<template>
  <td
    class="preview-parts-container-follow-button"
    :style="{padding: partDefaultPadding}"
  >
    <table
      border="0"
      cellpadding="0"
      cellspacing="0"
      style="width: 100%;"
      :style="wrapperStyle"
    >
      <tbody>
        <tr>
          <td>
            <table
              border="0"
              cellpadding="0"
              cellspacing="0"
              :style="containerStyle"
            >
              <tbody>
                <tr>
                  <td
                    style="width: 100%;"
                    :style="[innerStyle, { 'padding-top': partDefaultPadding }]"
                  >
                    <preview-part
                      :style="partsStyle"
                      v-for="part in partsContainer.parts"
                      :key="part.table_id"
                      :part="part"
                      :partsContainerId="partsContainer.id"
                      :sectionId="sectionId"
                      :columnCount="partsContainer.column_count"
                      :partWidth="partWidth"
                      :partsContainerType="partsContainer.type"
                      :partsContainerLayoutType="partsContainer.layout_type"
                      :partsContainerStyles="partsContainer.styles"
                      :partsContainerShareText="partsContainer.share_text"
                      :imageCardHorizontalDisplayRatio="null"
                      class="partsContainer, partsContainerDefault"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </table>
  </td>
</template>

<script>
import { partDefaultPadding } from '@/scss/variables.scss'
import PreviewPart from '@/components/Content/Preview/PreviewPart'

const MARGIN_CENTER = '0 auto'
const MARGIN_LEFT = '0 auto 0 0'
const MARGIN_RIGHT = '0 0 0 auto'

export default {
  props: [
    'partsContainer',
    'sectionId',
    'contentsWidth',
  ],
  data () {
    return {
      hoverActive: false,
      partDefaultPadding,
    }
  },
  components: {
    PreviewPart,
  },
  computed: {
    // パーツコンテナ外側のスタイル
    wrapperStyle () {
      if (!this.partsContainer) return null
      return {
        'background': this.partsContainer.styles['background'],
        'border': this.partsContainer.styles['border'],
      }
    },
    // パーツコンテナ内側のスタイル
    containerStyle () {
      if (!this.partsContainer) return null
      let style = null
      if (this.partsContainer.layout_type.match(/horizontal/)) {
        // 横レイアウト：幅を持たせる
        style = { 'width': '100%', 'margin': MARGIN_CENTER }
      } else if (this.partsContainer.layout_type.match(/vertical/)) {
        // 縦レイアウト：表示位置をmarginで設定
        switch (this.partsContainer.styles['align']) {
          case 'center':
            style = { 'margin': MARGIN_CENTER }
            break
          case 'left':
            style = { 'margin': MARGIN_LEFT }
            break
          case 'right':
            style = { 'margin': MARGIN_RIGHT }
            break
        }
      }
      return style
    },
    // パーツを囲むスタイル
    innerStyle () {
      if (!this.partsContainer) return null
      // 横レイアウト：表示位置をtext-alignで設定
      return this.partsContainer.layout_type.match(/horizontal/) ? { 'text-align': this.partsContainer.styles['align'] } : null
    },
    // パーツのレイアウト表示のためのスタイル
    // コンポーネント表示時にブロック要素が挿入されてしまうので、横レイアウトの場合は横並びできるようにしておく
    partsStyle () {
      if (!this.partsContainer) return null
      return this.partsContainer.layout_type.match(/horizontal/) ? { 'display': 'inline-block' } : null
    },
    // パーツ個別の幅
    partWidth () {
      if (!this.partsContainer) return null
      return {
        'width': this.contentsWidth / this.partsContainer.column_count + 'px',
      }
    },
  }
}
</script>
